import { createSlice } from '@reduxjs/toolkit';
import { numberOfItemsPerPage } from '../constants/globals';

const initialState = {
  history: {
    activePage: 0,
    pageSize: numberOfItemsPerPage,
    postData: null,
    filters: null,
  },
};

const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setHistory(state, action) {
      state.history = {
        ...state.history,
        ...action.payload,
      };
    },
    clearHistory(state) {
      state.history = initialState.history;
    },
  },
});

export const historyActions = historySlice.actions;

export default historySlice.reducer;
